/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';

import { Container, RangeSlider } from '@waca/ca-ui-toolkit';

/*
This is a common filter component that allows a filter to be applied to a range
of numbers using a slider control. There are also options to enter filter
values directly using text boxes, invert the current selection and specify whether to include
blank values.
*/
export default class NumericRangeFilter extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		minimumValue: PropTypes.number,
		maximumValue: PropTypes.number,
		fromValue: PropTypes.number.isRequired,
		toValue: PropTypes.number.isRequired,
		inverted: PropTypes.bool,
		decimalPlaces: PropTypes.number,
		onChange: PropTypes.func.isRequired,
		locale: PropTypes.string,
		readOnly: PropTypes.bool,
	};

	// Define default property values
	static defaultProps = {
		minimumValue: 0,
		maximumValue: 100,
		inverted: false,
		decimalPlaces: 5,
		readOnly: false,
		locale: undefined,
	};

	// Event handlers
	_onSliderValuesChanged = result => {
		const { inverted, onChange, decimalPlaces } = this.props;

		if (decimalPlaces > 0) {
			onChange({
				fromValue: parseFloat(result[0]),
				toValue: parseFloat(result[1]),
				inverted,
			});
		} else {
			onChange({
				fromValue: parseInt(result[0], 10),
				toValue: parseInt(result[1], 10),
				inverted,
			});
		}
	};

	render() {
		const {
			minimumValue,
			maximumValue,
			fromValue,
			toValue,
			inverted,
			readOnly,
			decimalPlaces,
		} = this.props;

		return (
			<Container data-tid="rangeSliderSection">
				<RangeSlider
					min={minimumValue}
					max={maximumValue}
					values={[fromValue, toValue]}
					inverted={inverted}
					onChange={this._onSliderValuesChanged}
					showInputBox
					showBoundaryLabels
					showTooltip
					scale={decimalPlaces}
					disabled={readOnly}
				/>
			</Container>
		);
	}
}
